import React from 'react';
import { useLanguage } from './LanguageContext';
import { Star } from 'lucide-react';
export const Reviews = () => {
  const {
    t
  } = useLanguage();
  const reviews = [{
    text: t('rev.c1.text'),
    name: t('rev.c1.name')
  }, {
    text: t('rev.c2.text'),
    name: t('rev.c2.name')
  }, {
    text: t('rev.c3.text'),
    name: t('rev.c3.name')
  }];
  return <section id="reviews" className="bg-brand-navy py-16 md:py-20" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        {/* Rating Summary */}
        <div className="text-center mb-10 md:mb-16" data-id="element-198">
          <h2 className="font-montserrat font-extrabold text-[56px] md:text-[80px] text-brand-gold leading-none mb-2" data-id="element-199">
            5.0
          </h2>
          <div className="flex justify-center gap-1 text-brand-gold mb-3" data-id="element-200">
            {[...Array(5)].map((_, i) => <Star key={i} size={24} className="md:w-7 md:h-7" fill="currentColor" data-id="element-201" />)}
          </div>
          <p className="font-inter text-white text-[13px] md:text-[14px] opacity-75" data-id="element-202">
            {t('rev.based')}
          </p>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-12" data-id="element-203">
          {reviews.map((review, index) => <div key={index} className="bg-white rounded-[16px] border-t-[3px] border-brand-gold py-5 px-4 md:p-8 shadow-[0_8px_30px_rgba(0,0,0,0.20)] hover:shadow-[0_12px_40px_rgba(201,168,76,0.35)] transition-shadow relative" data-id="element-204">
              <div className="absolute top-4 right-5 text-[64px] md:text-[80px] text-brand-gold/15 font-serif leading-none select-none" data-id="element-205">
                "
              </div>

              <div className="flex gap-1 text-brand-gold mb-3 md:mb-4 relative z-10" data-id="element-206">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-207" />)}
              </div>

              <p className="font-inter text-[14px] md:text-base text-gray-700 mb-5 md:mb-6 relative z-10 italic leading-[1.6]" data-id="element-208">
                "{review.text}"
              </p>

              <div className="relative z-10" data-id="element-209">
                <p className="font-montserrat font-bold text-brand-navy text-[15px] md:text-sm mb-1" data-id="element-210">
                  {review.name}
                </p>
                <p className="font-inter text-xs text-brand-gold font-medium" data-id="element-211">
                  {t('rev.badge')}
                </p>
              </div>
            </div>)}
        </div>

        {/* Bottom Bar */}
        <div className="text-center" data-id="element-212">
          <p className="font-inter text-brand-gold italic text-[13px] md:text-base" data-id="element-213">
            {t('rev.bottom')}
          </p>
        </div>
      </div>
    </section>;
};